import { IComponent, ICustomEventData } from '@modules/src/interfaces/IComponents'
import { ContainersNames } from '../../containers/ContainersNames'
import { AssetType } from '@modules/src/enums/AssetType'
import { Orientation } from '@modules/src/enums/Orientation'
import { ComponentEvent } from '@modules/src/enums/ComponentEvent'
import GameSignals from '@/signals/GameSignals'
import { ButtonState } from '@modules/src/enums/ButonStates'
import { ModuleSignals } from '@modules/src/signals/ModuleSignals'
import { ModulesFacade } from '@modules/src/ModulesFacade'
import * as PIXI from 'pixi.js'

export const FREE_SPINS_POPUPS_COMPONENT: IComponent = {
    name: ContainersNames.FREE_SPINS_POPUPS_CONTAINER,
    type: AssetType.CONTAINER,
    zIndex: new Map<Orientation, number>([
        [Orientation.LANDSCAPE, 420],
        [Orientation.PORTRAIT, 420],
    ]),
    visible: false,
    events: [
        {
            event: ComponentEvent.SHOW,
            onGameSignalsTriggered: [GameSignals.showFreeSpinsIntro, GameSignals.showFreeSpinsRetrigger],
        },
        {
            event: ComponentEvent.HIDE,
            onGameSignalsTriggered: [
                GameSignals.showFreeSpinsIntroComplete,
                GameSignals.showFreeSpinsRetriggerComplete,
                GameSignals.bonusStart,
            ],
        },
    ],
    items: [
        {
            name: 'Free Spins Intro Overlay',
            type: AssetType.OVERLAY,
            componentStyle: {
                color: 0x000000,
                opacity: 0.65,
            },
            events: [
                {
                    event: ComponentEvent.CUSTOM_NEW,
                    onGameSignalsTriggered: [
                        GameSignals.showFreeSpinsIntro,
                        GameSignals.showFreeSpinsRetrigger,
                        ModuleSignals.gameResized,
                    ],
                    callback: function (data: ICustomEventData) {
                        const overlay = data.component.componentElement as PIXI.Graphics
                        const width = ModulesFacade.currentSize.WORLD_WIDTH || 1920
                        const height = ModulesFacade.currentSize.WORLD_HEIGHT || 1080

                        overlay.clear()
                        overlay.beginFill(0x000000, 0.65)
                        overlay.drawRect(0, 0, width, height)
                        overlay.endFill()
                        overlay.pivot.set(width / 2, height / 2)
                        overlay.position.set(width / 2, height / 2)
                    },
                },
            ],
        },
        {
            name: 'Free Spins Intro Frame',
            type: AssetType.SPRITE,
            src: 'FRAME All.png',
            anchor: 0.5,
            scale: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 0.85,
                    y: 0.85,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 0.85,
                    y: 0.85,
                },
            ],
            position: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 492.5,
                    y: -90.5,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 4,
                    y: 290.5,
                },
            ],
        },
        {
            name: 'Free Spins Intro Start Button',
            type: AssetType.BUTTON,
            src: 'Button Normal.png',
            anchor: 0.5,
            scale: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 1,
                    y: 1,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 0.95,
                    y: 0.95,
                },
            ],
            position: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 749,
                    y: 709.5,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 284.5,
                    y: 1115,
                },
            ],
            buttonStates: [
                {
                    state: ButtonState.POINTER_UP_OUT,
                    src: 'Button Normal.png',
                    events: [],
                },
                {
                    state: ButtonState.POINTER_OUT,
                    src: 'Button Normal.png',
                    events: [],
                },
                {
                    state: ButtonState.POINTER_OVER,
                    src: 'Button Hover.png',
                    events: [],
                },
                {
                    state: ButtonState.POINTER_DOWN,
                    src: 'Button Down.png',
                    events: [],
                },
                {
                    state: ButtonState.POINTER_UP,
                    src: 'Button Normal.png',
                    events: [
                        {
                            event: ComponentEvent.TRIGGER_SIGNAL,
                            signalsToTrigger: [
                                GameSignals.showFreeSpinsIntroComplete,
                                GameSignals.showFreeSpinsRetriggerComplete,
                            ],
                        },
                    ],
                },
            ],
        },
        {
            name: 'Free Spins Intro Continue Label',
            type: AssetType.SPRITE,
            src: 'Continue Normal.png',
            anchor: 0.5,
            scale: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 1,
                    y: 1,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 0.95,
                    y: 0.95,
                },
            ],
            position: [
                {
                    orientation: Orientation.LANDSCAPE,
                    x: 749,
                    y: 709.5,
                },
                {
                    orientation: Orientation.PORTRAIT,
                    x: 287,
                    y: 1116.5,
                },
            ],
        },
    ],
}
